import './contact-copy.scss';

// Osmo — Copy Email to Clipboard Button, overgenomen van Osmo Supply. Classes
// en [data-copy-*] attributes zijn 1-op-1 Osmo.
//
// Afwijkend van Osmo:
//   1. aria-labels in het Nederlands; de label van de knop zelf blijft
//      bewaard en komt na het kopiëren terug.
//   2. Init ook als de DOM al klaar is (deze bundle laadt pas na de
//      pageloader, DOMContentLoaded is dan al geweest).
const LABEL_COPY = 'Kopieer het e-mailadres';
const LABEL_COPIED = 'E-mailadres gekopieerd';
const labelOf = (button) => button.dataset.copyLabel || LABEL_COPY;

function initCopyEmailClipboard() {
  const buttons = document.querySelectorAll('.copy-email-button');
  if (!buttons.length) return;

  const copyEmail = (button) => {
      // Email to copy to clipboard is taking from the button itself, or if that's empty,
    // from a text element inside the button
    const email =
      button.getAttribute('data-copy-email') ||
      button.querySelector('[data-copy-email-element]').textContent.trim();
    if (email) {
      navigator.clipboard.writeText(email).then(() => {
        button.setAttribute('data-copy-button', 'copied');
        button.setAttribute('aria-label', LABEL_COPIED);
      });
    }
  };

  const handleInteraction = (e) => {
    if (
      e.type === 'click' ||
      (e.type === 'keydown' && (e.key === 'Enter' || e.key === ' '))
    ) {
      e.preventDefault();
      copyEmail(e.currentTarget);
    }
  };

  buttons.forEach((button) => {
    button.dataset.copyLabel = button.getAttribute('aria-label') || LABEL_COPY;
    button.addEventListener('click', handleInteraction);
    button.addEventListener('keydown', handleInteraction);
    button.addEventListener('mouseleave', () => {
        // Remove 'active' attribute to reset color and text transform
      button.removeAttribute('data-copy-button');
      // Remove focus on mouseleave to clear keyboard focus styling
      button.blur();
      button.setAttribute('aria-label', labelOf(button));
    });
    button.addEventListener('blur', () => {
      button.removeAttribute('data-copy-button');
      button.setAttribute('aria-label', labelOf(button));
    });
  });
}

// Initialize Copy Email to Clipboard Button
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initCopyEmailClipboard();
  });
} else {
  initCopyEmailClipboard();
}
